import { useState, useCallback } from 'react';
import constate from 'constate';

/**
 * Hook for managing upgrade modal state
 * Provides open/close functionality with optional feature context
 */
const useUpgradeModalState = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [feature, setFeature] = useState<string | undefined>();

  /**
   * Opens the upgrade modal with optional feature context
   * @param featureDescription - Description of the feature requiring upgrade
   *                            e.g., "create more projects", "send test emails"
   */
  const openUpgradeModal = useCallback((featureDescription?: string) => {
    setFeature(featureDescription);
    setIsOpen(true);
  }, []);

  /**
   * Closes the upgrade modal and clears feature context
   */
  const closeUpgradeModal = useCallback(() => {
    setIsOpen(false);
    // Delay clearing feature to allow close animation
    setTimeout(() => setFeature(undefined), 200);
  }, []);

  return {
    isOpen,
    feature,
    openUpgradeModal,
    closeUpgradeModal,
  };
};

// Create context provider and hook using constate
export const [UpgradeModalProvider, useUpgradeModal] = constate(useUpgradeModalState);
